module.exports = __webpack_public_path__ + "img/headhunter-logo2.09608031.svg";